import { keywords } from '../parser/keywords.js';
import { getDecoratorInfo } from './decoratorUtils.js';

/**
 * Decorator to define arguments for parameterized tests.
 * Each application of this decorator adds a new test case to the target function.
 * 
 * @param args - The arguments to pass to the test function.
 */
export function testCase(...args: any[]) {

  return function (targetProto: any, childKey?: string) {
    const decInfo = getDecoratorInfo(childKey);
    if (decInfo.isClass) return;

    const target = targetProto[decInfo.key!];
    const isFunction = target instanceof Function;
    if (isFunction == false) return;

    const testCases = target[keywords.cases] || (target[keywords.cases] = []);

    testCases.push([...args]);
  }

}
